import { render, staticRenderFns } from "./How.vue?vue&type=template&id=689a4af3"
var script = {}
import style0 from "./How.vue?vue&type=style&index=0&id=689a4af3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports